import { Box, Center, Container, Stack, Text } from "@chakra-ui/react";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

import { RoleToggler } from "./RoleToggler";
import { useLocale, useTranslations } from "next-intl";
import videoThumb from "@root/public/images/video_thumb.png";
import Image from "next/image";
import { PlayButton } from "./PlayButton";
import { AbsoluteOverlay } from "./AbsoluteOverlay";
import { useState } from "react";
import { VideoModal } from "./VideoModal";
import { useRouter } from "next/router";

export const Presentation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations();
  const locale = useLocale();
  const router = useRouter();

  const revealVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const textRef = useRef(null);
  const descriptionRef = useRef(null);
  const imageRef = useRef(null);

  const textInView = useInView(textRef, { once: true });
  const descriptionInView = useInView(descriptionRef, { once: true });
  const imageInView = useInView(imageRef, { once: true });

  return (
    <Box
      bgColor="black.50"
      color="black.900"
      w="full"
      p={{ base: 8, md: 16 }}
      px={{ base: 4, md: 16 }}
      id="presentation"
    >
      <Container maxW="container.xl">
        <Stack
          direction={["column", "row"]}
          alignItems={"start"}
          mb={16}
          gap={8}
          px={{
            base: 8,
            md: 16,
          }}
        >
          <motion.div
            ref={textRef}
            initial="hidden"
            animate={textInView ? "visible" : "hidden"}
            variants={revealVariants}
          >
            <Text
              w="full"
              fontWeight={500}
              fontSize={"4xl"}
              textAlign={{
                base: "center",
                md: "left",
              }}
            >
              {t("landingPage.presentation")}
            </Text>
          </motion.div>
          <motion.div
            ref={descriptionRef}
            initial="hidden"
            animate={descriptionInView ? "visible" : "hidden"}
            variants={revealVariants}
          >
            <Text
              w="full"
              fontWeight={400}
              fontSize={"xl"}
              textAlign={{
                base: "center",
                md: "left",
              }}
              dangerouslySetInnerHTML={{
                __html: t("landingPage.presentationDescription"),
              }}
            ></Text>
          </motion.div>
        </Stack>
        <Center mb={16} w="full">
          <motion.div
            ref={imageRef}
            initial="hidden"
            animate={imageInView ? "visible" : "hidden"}
            variants={revealVariants}
          >
            <Box
              w="full"
              maxWidth={{
                base: "full",
                md: "700px",
              }}
              border="8px solid"
              borderColor="black.900"
              position="relative"
            >
              <Image src={videoThumb} alt="Video Thumb" quality={80} />
              <AbsoluteOverlay>
                <PlayButton onClick={() => setIsOpen(true)} />
              </AbsoluteOverlay>
            </Box>
          </motion.div>
        </Center>
        <RoleToggler
          clickCallback={(role) =>
            router.push(`/${locale}/to-whom?scrollTo=${role}`)
          }
        />
      </Container>
      <VideoModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        videoUrl={
          locale === "pt"
            ? "https://coach-platform-public.s3.eu-west-2.amazonaws.com/videos/CLARIFAYO_PT_24.mp4"
            : "https://coach-platform-public.s3.eu-west-2.amazonaws.com/videos/Clarifayo_EN_24.mp4"
        }
      />
    </Box>
  );
};
